<div [ngClass]="{ 'isg-hide': impersonating() == '', 'isg-impersonate-current-wrapper' : (true)}">
  <span>Impersonating: {{impersonating()}}</span>
  <button kendoButton type="button"
          class="isg-button-icon"
          (click)="onStopImpersonating()">
    <i class="fa-solid fa-xmark" title="Stop Impersonating"></i>
  </button>
</div>
